import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import './assets/css/style.scss';
import './assets/css/mobile.scss';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import './i18n/i18n';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { MultiBackend, MouseTransition, TouchTransition } from 'react-dnd-multi-backend';
import { DELAY_TOUCH_START } from './constant/constants';
import { hydrateAuth } from './service/auth-session';

hydrateAuth();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

export const HTML5toTouchWithLongPress = {
  backends: [
    {
      id: 'html5',
      backend: HTML5Backend,
      transition: MouseTransition,
    },
    {
      id: 'touch',
      backend: TouchBackend,
      preview: true,
      transition: TouchTransition,

      options: {
        enableMouseEvents: true,
        delayTouchStart: DELAY_TOUCH_START,
        ignoreContextMenu: true,
      },
    },
  ],
};

root.render(
  <Provider store={store}>
    <StrictMode>
      <DndProvider backend={MultiBackend} options={HTML5toTouchWithLongPress}>
        <App></App>
      </DndProvider>
    </StrictMode>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
